import { BonusByProductCardsTranslations } from ".";

export const BONUS_BY_PRODUCT_CARDS_ES_MX: BonusByProductCardsTranslations = {
	totalProductsValue: "Bonificación total en Productos",
	totalTipValue: "Bonificación total en propina",
	totalValue: "Total",
	receivedInPeriod: "Recibido en el evento",
	receivedAtAnotherPeriod: "Recibido en otros eventos",
};
